import { useState, useEffect } from "react";
import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export function VersionBadge() {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    // Add timestamp to prevent caching
    fetch(`/version.json?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setVersion(data))
      .catch(() => setVersion({ version: "1.00", lastUpdate: new Date().toISOString() }));
  }, []);

  if (!version) return null;

  const formatDate = (isoString) => {
    try {
      const date = parseISO(isoString);
      const estDate = toZonedTime(date, "America/New_York");
      return format(estDate, "MMM d, yyyy h:mm a") + " EST";
    } catch {
      return "Unknown";
    }
  };

  return (
    <div 
      className="fixed bottom-4 right-4 flex items-center gap-2 text-xs text-slate-500 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm border border-slate-200 z-50"
      data-testid="version-badge"
    >
      <span className="px-2 py-0.5 bg-slate-100 rounded font-mono font-medium">
        v{version.version}
      </span>
      <span className="hidden sm:inline text-slate-400">
        {formatDate(version.lastUpdate)}
      </span>
    </div>
  );
}
